import React, { useEffect, useState } from 'react';
import { getToken } from '../utils/auth';

const API = process.env.REACT_APP_BACKEND_URL;
const cache = {};

const isPreview = () => typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('site_preview') === '1';

// Founder-edited website text/images with safe fallback to the built-in copy.
export const useSiteContent = (sectionKey) => {
  const preview = isPreview() && !!getToken();
  const mode = preview ? 'draft' : 'public';
  const [all, setAll] = useState(cache[mode] || null);
  useEffect(() => {
    if (cache[mode]) return;
    const req = preview
      ? fetch(`${API}/api/admin/console/site-content-draft`, { headers: { Authorization: `Bearer ${getToken()}` } })
      : fetch(`${API}/api/site-content`);
    req.then((r) => (r.ok ? r.json() : { content: {} })).then((d) => { cache[mode] = d.content || {}; setAll(cache[mode]); }).catch(() => {});
  }, [mode, preview]);
  const vals = (all || {})[sectionKey] || {};
  const text = (field, lang, fallback) => vals[field]?.[lang] || fallback;
  const image = (field, fallback) => (vals[field]?.url ? `${API}${vals[field].url}` : fallback);
  return { text, image, preview };
};

export const SitePreviewBadge = ({ show }) => (show ? (
  <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] rounded-full bg-amber-500 text-slate-950 px-4 py-2 text-sm font-semibold shadow-lg" data-testid="site-preview-badge">
    Preview of unpublished changes · Vista previa sin publicar
  </div>
) : null);

export default useSiteContent;
